/**
 * Homepage hero sliders intentionally stay short so their navigation remains
 * legible and important campaigns are not hidden deep in the rotation.
 */
export const HERO_SECTION_SLIDER_MAX_SLIDES = 5;
